"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.v19Upgrade = exports.v19Downgrade = void 0;
/**
 * SplitUrlTestRule:
 * - Remove rule.conversionGoals
 * - Add trackingId to variants
 * - Rename trackingGroupId to experimentId
 */
const v19Downgrade = (actRule) => {
    if (actRule.type === 'embeddable') {
        return { ...actRule, schemaVersion: 18 };
    }
    const { state, trackingGroupId, forwardQueryParams, gdprComplianceRequired, variants } = actRule.rule;
    // Add empty string for trackingId to variants
    const v18Variants = variants.map(({ letter, name, weight, url }) => ({ letter, name, weight, url, trackingId: '' }));
    return {
        ...actRule,
        schemaVersion: 18,
        rule: {
            state,
            experimentId: trackingGroupId,
            forwardQueryParams,
            gdprComplianceRequired,
            variants: v18Variants,
        },
    };
};
exports.v19Downgrade = v19Downgrade;
/**
 * SplitUrlTestRule:
 * - Add rule.conversionGoals
 * - Remove trackingId from variants
 * - Rename experimentId to trackingGroupId
 */
const v19Upgrade = (actRule) => {
    if (actRule.type === 'embeddable') {
        return { ...actRule, schemaVersion: 19 };
    }
    const { experimentId, variants, ...restRule } = actRule.rule;
    // Remove trackingId from variants
    const v19Variants = variants.map(({ letter, name, weight, url }) => ({
        letter,
        name,
        weight,
        url,
    }));
    return {
        ...actRule,
        schemaVersion: 19,
        rule: {
            ...restRule,
            variants: v19Variants,
            trackingGroupId: experimentId,
            conversionGoals: [],
        },
    };
};
exports.v19Upgrade = v19Upgrade;
//# sourceMappingURL=v19.js.map